//---------------------------------------------------------------//
// Sidebar Menu
//---------------------------------------------------------------//

// variables first
const $sidebarNavItemWithChildren = $('.sidebar-menu li.is-parent > span');
const sidebarSubmenuOpen = 'sub-menu-open';
const sidebarActiveItem = 'item-active';
const sidebarActiveChildren = 'active-children';
const leftSidebarHeight =
  $(window).outerHeight() -
  $('header.site-header').outerHeight() -
  $('nav.main-menu').outerHeight() -
  $('#sidebar .sidebar-header').outerHeight();
const leftSidebarHeightAdjusted =
  $(window).outerHeight() - $('#sidebar .sidebar-header').outerHeight();

// initially set the height of sidebar to allow for the overflow scrolling
$('#sidebar .sidebar-content').css('height', leftSidebarHeight);

// Open Sidebar function
function openSidebar() {
  $('#sidebar').css('width', '240px').addClass('sidebar-open');
  $('#content-and-footer-wrapper').css('width', 'calc(100% - 240px)');
  $('#sidebar .sidebar-content').slideToggle(750);
  $('#sidebar .sidebar-header .sidebar-menu-button')
    .css('display', 'none')
    .addClass('active');
  // need to delay the fading in of the element to prevent the "jumping" being seen before the hamburger has a chance to hide fully
  setTimeout(function () {
    $('#sidebar .sidebar-header .show-open').fadeIn();
  }, 200);
}

// Close Sidebar function
function closeSidebar() {
  $('#sidebar').css('width', '45px').removeClass('sidebar-open');
  $('#content-and-footer-wrapper').css('width', 'calc(100% - 45px)');
  $('#sidebar .sidebar-content').slideToggle(0);
  $('#sidebar .sidebar-header .sidebar-menu-button')
    .css('display', 'flex')
    .removeClass('active');
  $('#sidebar .sidebar-header .show-open').hide();
}

let sidebarOpen = true;

// Open or collapse the sidebar
$('.sidebar-header').on('click', function () {
  if (!sidebarOpen) {
    openSidebar();
    sidebarOpen = !sidebarOpen;
  } else {
    closeSidebar();
    sidebarOpen = false;
  }
});

// When going down to mobile, need to remove any widths that got added by either of the above functions
function resetContentAndFooterWrapper() {
  if (window.innerWidth < 1000) {
    $('#content-and-footer-wrapper').removeAttr('style');
  }
}
$(window).resize(resetContentAndFooterWrapper);

// handle the click of those special .is-parent menu items within the sidebar
$sidebarNavItemWithChildren.on('click', (evt) => {
  if (window.innerWidth > 1000) {
    const $this = $(evt.currentTarget);

    $(`.${sidebarActiveItem}`)
      .not($this)
      .not($this.parents('.sidebar-menu-level-2').siblings())
      .removeClass(sidebarActiveItem)
      .parent()
      .removeClass(sidebarActiveChildren);

    $this
      .toggleClass(sidebarActiveItem)
      .parent()
      .toggleClass(sidebarActiveChildren);

    // look for any open submenus that are not itself or a parent
    // and close them and remove class
    $(`.${sidebarSubmenuOpen}`)
      .not($this.parents())
      .not($this.next('ul'))
      .slideToggle()
      .toggleClass(sidebarSubmenuOpen);

    // toggle the submenu and class
    $this.next('ul').slideToggle().toggleClass(sidebarSubmenuOpen);
  }
});

//---------------------------------------------------------------//
// Affixing the Sidebar Menu
//---------------------------------------------------------------//

// Grab the target element
const sidebarPosition = $('#sidebar-inner').position();
if (sidebarPosition) {
  window.addEventListener('scroll', function () {
    if ($(window).scrollTop() > sidebarPosition.top) {
      $('#sidebar-inner').addClass('affix');
      // IF THE SPEAKER MODE BANNER IS VISIBLE
      if ($('#speaker-mode-banner').is(':visible')) {
        $('#sidebar-inner').css('top', '20px');
      }
      // adjust the height of .sidebar-content
      $('#sidebar .sidebar-content').css('height', leftSidebarHeightAdjusted);
    } else {
      $('#sidebar-inner').removeClass('affix');
      // re-adjust the height of .sidebar-content
      $('#sidebar .sidebar-content').css('height', leftSidebarHeight);
    }
  });
}
